<header class="bg-turquoise text-grey-dark flex flex-row justify-between items-center py-5 px-10 md:px-16 md:py-12 font-sans"
        #modalheader>
  <ng-container *ngTemplateOutlet="defaultBackButton"></ng-container>
  <h1 class="font-sans text-sm md:text-lg text-center text-grey-dark font-bold flex-grow">
    <ng-content></ng-content>
  </h1>
  <button (click)="close()"
          *ngIf="dismissible">
    <figure>
      <svg viewBox="0 0 14 15"
           fill="none"
           class="stroke-current h-5"
           xmlns="http://www.w3.org/2000/svg">
        <path d="M13 1.5L1 13.5"
              stroke="current"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round" />
        <path d="M1 1.5L13 13.5"
              stroke="current"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round" />
      </svg>
    </figure>
  </button>
</header>

<ng-template #defaultBackButton>
  <div [class.opacity-0]="!backEnabled" [class.pointer-events-none]="!backEnabled">
    <button class="hidden md:flex flex-row gap-2 items-center text-base font-bold text-grey-dark"
            (click)="back.emit()"
            *ngIf="canGoBack">
      <figure>
        <svg viewBox="0 0 7 13"
            xmlns="http://www.w3.org/2000/svg"
            class="fill-current h-4"
        >
          <path fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.25628 5.8939C-0.0854265 6.22862 -0.0854265 6.77136 0.25628 7.10608L5.50631 12.249C5.84799 12.5837 6.40205 12.5837 6.74373 12.249C7.08542 11.9142 7.08542 11.3715 6.74373 11.0368L2.11243 6.49999L6.74373 1.96321C7.08542 1.6285 7.08542 1.08575 6.74373 0.751037C6.40205 0.416322 5.84799 0.416322 5.50631 0.751037L0.25628 5.8939Z"
                fill="current" />
        </svg>
      </figure>
      {{backLabel}}
    </button>

    <button class="md:hidden"
            (click)="back.emit()">
      <svg width="24px" height="14px" viewBox="0 0 24 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Group">
            <path d="M23.5,6.5858175 C23.5,6.5074175 23.4577,6.3941175 23.3047,6.2820175 C23.1521,6.1702175 22.9169,6.0858175 22.635,6.0858175 L3.36497004,6.0858175 C3.08299004,6.0858175 2.84786004,6.1702175 2.69525004,6.2820175 C2.54234004,6.3940175 2.50000004,6.5074175 2.50000004,6.5858175 C2.50000004,6.6642175 2.54232004,6.7775175 2.69526004,6.8896175 C2.84789004,7.0014175 3.08302004,7.0858175 3.36497004,7.0858175 L22.635,7.0858175 C22.9169,7.0858175 23.1521,7.0014175 23.3047,6.8896175 C23.4577,6.7775175 23.5,6.6641175 23.5,6.5858175 Z" id="Path" stroke="#374649" fill="#ED0000" fill-rule="nonzero"></path>
            <path d="M0.293221038,7.3643175 L5.94978004,13.0208175 C6.34030004,13.4114175 6.97346004,13.4114175 7.36399004,13.0208175 C7.75451004,12.6303175 7.75451004,11.9971175 7.36399004,11.6066175 L2.41421004,6.6568175 L7.36396004,1.7071075 C7.75448004,1.3165875 7.75449004,0.6834175 7.36396004,0.2928975 C6.97344004,-0.0976325 6.34027004,-0.0976325 5.94975004,0.2928975 L0.292893038,5.9497175 C-0.0976308625,6.3403175 -0.0976311625,6.9734175 0.292893038,7.3639175 C0.292903038,7.3640175 0.292912038,7.3640175 0.292922038,7.3640175 L0.293221038,7.3643175 Z" id="Path" fill="#374649"></path>
          </g>
        </g>
      </svg>

    </button>
  </div>
</ng-template>

